import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { postWithdraw } from 'services/WalletsService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useWithdrawMutation = () => {
  const errorsCodeToIgnore = [428, 403]

  return useMutation({
    mutationFn: postWithdraw,
    onError: (error: BaseErrorResponse, data) => {
      if (!errorsCodeToIgnore.includes(error?.status)) {
        logSentryError('Error: useWithdrawMutation', error, data)
      }
    },
  })
}
